import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/threats/incidents/{-$id}')({
  beforeLoad: () =>
    getTitleContextSlice(window.location.pathname.toLowerCase().endsWith('/threats/incidents') ? 'Incidents' : 'Incident Detail'),
  staticData: {
    owner: CodeOwner.SWB,
  },
});
